import AnalyticsEvents_V2, { GenericEvents } from '~/analytics/analyticsGA4'
import { PortalProducts } from '~/analytics/types/analytics.type'

class StartAnalytics extends AnalyticsEvents_V2 {
  public constructor() {
    super(PortalProducts.CAMPAIGN)
  }
  public logButtonClick(title: string, label?: string): void {
    this.logEvent({
      event: GenericEvents.BUTTON_CLICK,
      title,
      label,
    })
  }
  public logCtaClick(title: string, label: string): void {
    this.logEvent({
      event: GenericEvents.CTA_CLICK,
      title,
      label,
    })
  }
  public logSectionView(section: number, section_title: string): void {
    this.logEvent({
      event: GenericEvents.SECTION_VIEW,
      section,
      section_title,
    })
  }
  public logVideoSection(action: string, duration: number, isCompleted: boolean): void {
    this.logEvent({
      event: GenericEvents.VIDEO_VIEW,
      action,
      duration,
      isCompleted,
    })
  }
}

export default new StartAnalytics()
